(() => {
  function init() {
    document.querySelectorAll('[data-range-product], [data-pdp]').forEach(root => {
      const row = root.querySelector('.rg-price, .ds-price-row');
      if (!row || row.querySelector('.st-save')) return;
      const badge = document.createElement('span');
      badge.className = 'st-save'; badge.hidden = true;
      badge.setAttribute('aria-live', 'polite'); row.append(badge);
      function update() {
        let price = 0, compare = 0;
        const select = root.querySelector('[data-variant]');
        if (select) {
          const option = select.selectedOptions[0];
          price = Number(option?.dataset.price); compare = Number(option?.dataset.compare);
        } else {
          try {
            const variants = JSON.parse(root.querySelector('[data-range-variants]').textContent);
            const selected = Array.from(root.querySelectorAll('[data-option-position]')).map(el => el.querySelector('input:checked')?.value);
            const variant = selected.length ? variants.find(v => selected.every((value, i) => value === v.options[i])) : variants[0];
            price = Number(variant?.price); compare = Number(variant?.compare_at_price);
          } catch (_) { badge.hidden = true; return; }
        }
        badge.hidden = !(price > 0 && compare > price);
        if (!badge.hidden) {
          const currency = root.dataset.currency || document.body.dataset.currency || 'USD';
          badge.textContent = tr('s133', {amount: new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format((compare-price)/100)});
        }
      }
      root.addEventListener('change', update); update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
